<template>
  <div class="container">
    <div class="row pt-10 pb-5 text-left container-content">
      <h4 class="heading mt-5">Access Denied!</h4>
    </div>
  </div>
</template>

<script>

export default {
  name: "ErrPage"
};
</script>
<style scoped>
.heading {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #dc3545;
}
</style>
